import React from 'react';

function AboutOurVisionSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '64px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 48,
      flexWrap: 'wrap'
    },
    textCol: {
      flex: '1 1 0',
      minWidth: 260,
      maxWidth: 520,
      textAlign: 'left'
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineRule: {
      display: 'inline-block',
      width: 150,
      height: 0,
      borderBottom: '2px solid #E73123',
      marginLeft: 12,
      verticalAlign: 'middle',
      opacity: 1
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: '8px 0 0 0'
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: '4px 0 0 0'
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '28px',
      letterSpacing: 0,
      color: '#838383',
      margin: '16px 0 0 0'
    },
    imageCol: {
      flex: '0 0 520px',
      width: 520,
      maxWidth: '100%',
      minWidth: 0
    },
    image: {
      width: '100%',
      maxWidth: 520,
      aspectRatio: '1',
      objectFit: 'cover',
      display: 'block',
      opacity: 1
    }
  };

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.imageCol },
      React.createElement('img', {
        src: '/ourvision.jpg',
        alt: 'Construction - Sunrise Properties vision',
        style: styles.image
      })
    ),
    React.createElement('div', { style: styles.textCol },
      React.createElement('h2', { style: styles.overline },
        'OUR VISION',
        React.createElement('span', { style: styles.overlineRule })
      ),
      React.createElement('h3', { style: { margin: '8px 0 0 0', textAlign: 'left' } },
        React.createElement('span', { style: styles.titleRed }, 'SETTING THE BENCH-'),
        React.createElement('br'),
        React.createElement('span', { style: styles.titleBlack }, 'MARK IN QUALITY AND'),
        React.createElement('br'),
        React.createElement('span', { style: styles.titleBlack }, 'EFFICIENCY')
      ),
      React.createElement('p', { style: styles.body },
        "The company's vision is to be the top choice in the market when it comes to construction. We envision to be the leading construction firm in India & Abroad that provides efficient and high-quality construction services to the people."
      )
    )
  );
}

export default AboutOurVisionSection;
